import { useCallback } from "react";
import apiClient from "../../../helpers/apiClient";
import i18n from "../../../config/i18_init";
import { buildCheckInReservationPatch } from "../utils/checkInOut";
import { buildCarImagesPayload, uploadCheckInImageFiles } from "../utils/checkInImageHelpers";
import { preserveInvoicePaymentHistory } from "../utils/invoiceHelpers";

export default function useCheckInSubmit() {
    const submitCheckIn = useCallback(async (reservation, data, toast) => {
        if (!reservation?.id) {
            throw new Error("Reservation ID is required");
        }

        try {
            const uploaded = await uploadCheckInImageFiles({
                walkaroundFiles: data.walkaroundFiles,
                dashboardFile: data.dashboardFile,
            });

            const carImages = buildCarImagesPayload(uploaded);
            const patchPayload = buildCheckInReservationPatch({
                carImages,
                fuelLevel: data.fuelLevel,
                mileage: data.mileage,
                preserveOngoing: data.preserveOngoing,
                reservationOngoing: reservation.ongoing,
                earlyPickupDateTime: data.earlyPickupDateTime,
            });

            if (data.earlyCheckInInvoice) {
                patchPayload.invoice = preserveInvoicePaymentHistory(data.earlyCheckInInvoice, reservation);
            }

            await apiClient.patch(`/api/reservation/${reservation.id}`, patchPayload);
        } catch (error) {
            toast.error({
                message: i18n.t("checkIn:checkInFailed"),
                description: error?.response?.data?.message || error?.message,
            });
            throw error;
        }
    }, []);

    return { submitCheckIn };
}
